
export const topMPUProps = {
  adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/ros/top_mpu',
  type: "topMPU"
};

export const singleBottomMPUProps = {
  adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/ros/bottom_mpu',
  type: 'singleBottomMPU'
};

export const bannerAd = {
  adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/ros/top_banner',
  type: "topBanner"
};

export const rosBottomMpuProps = {
  adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/ros/Bottom_MPU',
  type: 'bottomMPU'
};

export const bottomMPUProps = {
  adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/ros/Bottom_MPU',
  type: 'bottomMPU'
};



// WEBPACK FOOTER //
// ./modules/Common/components/GptProperties.js